import { useEffect, useState } from 'react'

// 浏览器 IP 地域判定（全站统一）：大陆（不含港澳台）为 'cn'，海外/接口失败为 'oversea'
// ?isoversea=1 跳过判断，直接按海外展示（预览用）；结果缓存在 sessionStorage 避免每次跳转重复请求
export type RegionState = 'checking' | 'cn' | 'oversea'

const IP_API = 'https://sms.mmopk.net:8989/myip2'
const CACHE_KEY = 'yygame_region'

export function useRegion(): RegionState {
    const [region, setRegion] = useState<RegionState>('checking')

    useEffect(() => {
        if (new URLSearchParams(window.location.search).get('isoversea') === '1') {
            setRegion('oversea')
            return
        }
        try {
            const cached = sessionStorage.getItem(CACHE_KEY)
            if (cached === 'cn' || cached === 'oversea') {
                setRegion(cached)
                return
            }
        } catch { }
        fetch(IP_API, { cache: 'force-cache' })
            .then((res) => res.json())
            .then((data) => {
                const r: RegionState =
                    data.result.Country == 'CN' &&
                        data.result.Province != '香港' &&
                        data.result.Province != '澳门' &&
                        data.result.Province != '台湾'
                        ? 'cn'
                        : 'oversea'
                try { sessionStorage.setItem(CACHE_KEY, r) } catch { }
                setRegion(r)
            })
            .catch(() => setRegion('oversea'))
    }, [])

    return region
}
